import { connect } from 'react-redux';
import React from 'react';

import PageSelector from 'components/PageSelector';
import { getMailPaging } from 'selectors';
import * as actions from 'actions';

const MailThreadsListPageSelector = props => <PageSelector {...props} />;

const mapStateToProps = state => getMailPaging(state, 'mailThreads');

const mapDispatchToProps = dispatch => {
  return {
    onPrevClick: currentPage => {
      dispatch(actions.mailThreadsFetch(currentPage - 1));
    },
    onNextClick: currentPage => {
      dispatch(actions.mailThreadsFetch(currentPage + 1));
    },
    onPossiblePageUpdate: newPossiblePage => {
      dispatch(actions.mailThreadsUpdatePossiblePage(newPossiblePage));
    },
    onPageUpdate: (newPage, pagesCount) => {
      if(newPage >= 1 && newPage <= pagesCount) {
        dispatch(actions.mailThreadsFetch(newPage));
      }
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MailThreadsListPageSelector);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Mail/MailThreadsList/MailThreadsListPageSelector/index.js
 **/